import { extendTheme } from '@chakra-ui/react';
import '@fontsource/open-sans/600.css';
import { breakpoints } from '@lon/shared/assets';

const theme = extendTheme({
  breakpoints,
});

export default theme;
